import { render, staticRenderFns } from "./FlexibleSectionTitle.vue?vue&type=template&id=ec9e2e0c"
import script from "./FlexibleSectionTitle.vue?vue&type=script&lang=js"
export * from "./FlexibleSectionTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageTitle: require('/vercel/path0/components/PageTitle/PageTitle.vue').default,BaseSection: require('/vercel/path0/components/Base/Section/BaseSection.vue').default})
